<div class="card overflow-hidden">
  <div class="card-img-top position-relative">
    <img *ngIf="imageSrc" [src]="imageSrc" class="img-fluid" />
    <div
      *ngIf="!imageSrc"
      class="img-placeholder d-flex align-items-center justify-content-center bg-light"
    >
      <span class="text-muted small">{{ "general.noImage" | translate }}</span>
    </div>

    @if (project().classification; as classification) {
      @if (classification.code) {
        <div
          class="classification-badge {{
            classification.code.split('-')[0].toLowerCase()
          }}"
          [title]="classification.description"
        >
          {{ classification.code }}
        </div>
      }
    }
  </div>
  <div class="card-body">
    <div class="card-title" [title]="project().name">{{ project().name }}</div>
    <div class="project-details-block">
      @if (project().interestMin != null || project().interestMax != null) {
        <div class="project-detail-line">
          <div class="project-description">
            {{ "projectCard.interestValueCommitted" | translate }}
          </div>
          <small
            ><b
              >{{ project().interestMin ?? "-" }}% -
              {{ project().interestMax ?? "-" }}%</b
            ></small
          >
        </div>
      }
      @if (project().yieldMin != null || project().yieldMax != null) {
        <div class="project-detail-line">
          <div class="project-description">
            {{ "projectCard.recommendedYield" | translate }}
          </div>
          <small
            ><b
              >{{ project().yieldMin ?? "-" }}% -
              {{ project().yieldMax ?? "-" }}%</b
            ></small
          >
        </div>
      }
      @if (project().loanTypePaymentStart && project().loanTypePaymentEnd) {
        <div class="project-detail-line">
          <div class="project-description">
            {{ "projectCard.term" | translate }}
          </div>
          <small
            ><b>{{
              project().loanTypePaymentStart
                | periodDuration: project().loanTypePaymentEnd
            }}</b></small
          >
        </div>
        <div class="project-detail-line">
          <div class="project-description">
            {{ "projectCard.collectionPeriod" | translate }}
          </div>
          <small>
            <b
              >{{ getDateString(project().loanTypePaymentStart!) }} -
              {{ getDateString(project().loanTypePaymentEnd!) }}</b
            ></small
          >
        </div>
      }
      @if (project().targetColletionEndDate) {
        <div class="project-detail-line">
          <div class="project-description">
            {{ "projectCard.scheduledPaymentDate" | translate }}
          </div>
          <small
            ><b>{{
              getDateString(project().targetColletionEndDate!)
            }}</b></small
          >
        </div>
      }
    </div>
    @if (getShowGoalSection()) {
      <hr />
      <div class="goal-block">
        <small>{{
          "projectCard.goalText"
            | translate
              : {
                  goal: getGoalTarget(),
                  currency: project().currency,
                  progress: getGoalProgress() ?? 0 | threeDecimals,
                }
        }}</small>
        <div class="goal-amount">
          {{ getGoalCurrent() }} {{ project().currency }}
        </div>
        @if (isInvestOpen()) {
          <small>{{ "projectCard.investmentsArePossible" | translate }}</small>
        }
      </div>
    }
    @if (investment() && isInvestmentDisplayType()) {
      <hr />
      <div class="investment-section">
        @if (displayType() === "pendingInvestments") {
          <div class="investment-item investment-item-pending">
            <div class="investment-item-label">
              {{ "projectCard.investment.amountToInvest" | translate }}
            </div>
            <div class="investment-value-row investment-value-row-pending">
              <span
                class="investment-value-with-copy investment-amount-pending"
              >
                {{ investment()!.amount }}
                {{ investment()!.projectCurrency ?? project().currency }}
              </span>
              @if (
                investment()!.pendingUntil &&
                getPendingUntilCountdown(investment()!.pendingUntil)
              ) {
                <button
                  type="button"
                  class="btn btn-primary btn-withdrawal-countdown"
                  (click)="cancelPendingInvestment()"
                >
                  {{
                    "projectCard.investment.withdrawalCountdown"
                      | translate
                        : {
                            countdown: getPendingUntilCountdown(
                              investment()!.pendingUntil
                            ),
                          }
                  }}
                </button>
              }
            </div>
          </div>
        } @else if (
          displayType() === "acceptedInvestments" && isActiveFundedInvestment()
        ) {
          <div class="investment-item">
            <div class="investment-item-label">
              {{ "projectCard.investment.amountInvested" | translate }}
            </div>
            <div class="investment-value-row">
              <span class="investment-value-with-copy">
                {{ investment()!.amount }}
                {{ investment()!.projectCurrency ?? project().currency }}
              </span>
            </div>
          </div>
        } @else {
          <div class="investment-item">
            <div class="investment-item-label">
              {{ "projectCard.investment.amountToInvest" | translate }}
            </div>
            <div class="investment-value-row">
              <span class="investment-value-with-copy">
                {{ investment()!.amount }}
                {{ investment()!.projectCurrency ?? project().currency }}
                <button
                  type="button"
                  class="btn btn-link btn-copy p-0"
                  (click)="
                    copyToClipboard(
                      investment()!.amount +
                        ' ' +
                        (investment()!.projectCurrency ?? project().currency)
                    )
                  "
                  title="{{ 'general.copy' | translate }}"
                >
                  <span class="fas fa-copy"></span>
                </button>
              </span>
            </div>
          </div>
          @if (hasDisplayAccountOwner()) {
          <div class="investment-item">
            <div class="investment-item-label">
              {{ "projectCard.investment.accountOwner" | translate }}
            </div>
            <div class="investment-value-row">
              <span class="investment-value-with-copy">
                {{ getDisplayAccountOwner() }}
                <button
                  type="button"
                  class="btn btn-link btn-copy p-0"
                  (click)="copyToClipboard(getDisplayAccountOwner())"
                  title="{{ 'general.copy' | translate }}"
                >
                  <span class="fas fa-copy"></span>
                </button>
              </span>
            </div>
          </div>
          }
          @if (hasDisplayAccountNumber()) {
          <div class="investment-item">
            <div class="investment-item-label">
              {{ "projectCard.investment.accountNumber" | translate }}
            </div>
            <div class="investment-value-row">
              <span class="investment-value-with-copy">
                {{ getDisplayAccountNumber() }}
                <button
                  type="button"
                  class="btn btn-link btn-copy p-0"
                  (click)="copyToClipboard(getDisplayAccountNumber())"
                  title="{{ 'general.copy' | translate }}"
                >
                  <span class="fas fa-copy"></span>
                </button>
              </span>
            </div>
          </div>
          }
          @if (hasDisplayComment()) {
          <div class="investment-item">
            <div class="investment-item-label">
              {{ "projectCard.investment.comment" | translate }}
            </div>
            <div class="investment-value-row">
              <span class="investment-value-with-copy">
                {{ getDisplayComment() }}
                <button
                  type="button"
                  class="btn btn-link btn-copy p-0"
                  (click)="copyToClipboard(getDisplayComment())"
                  title="{{ 'general.copy' | translate }}"
                >
                  <span class="fas fa-copy"></span>
                </button>
              </span>
            </div>
          </div>
          }
          @if (
            displayType() === "acceptedInvestments" &&
            investment()!.pendingUntil &&
            getPendingUntilCountdown(investment()!.pendingUntil)
          ) {
            <div class="withdrawal-countdown">
              <button
                type="button"
                class="btn btn-outline-primary btn-sm"
                disabled
              >
                {{
                  "projectCard.investment.withdrawalCountdown"
                    | translate
                      : {
                          countdown: getPendingUntilCountdown(
                            investment()!.pendingUntil
                          ),
                        }
                }}
              </button>
            </div>
          }
        }
      </div>
    }
    @if (isFundraisingCard()) {
      <div class="fundraising-actions">
        <a
          class="fundraising-btn fundraising-btn-primary"
          [class.fundraising-btn-disabled]="!hasIncomingOffers()"
          [attr.aria-disabled]="!hasIncomingOffers()"
          [attr.tabindex]="!hasIncomingOffers() ? -1 : null"
          (click)="hasIncomingOffers() && onIncomingOffersClicked.emit(project().id)"
        >
          <span class="fas fa-check"></span>
          {{
            "projectCard.fundraising.incomingOffers"
              | translate: { count: getIncomingOffersCountText() }
          }}
        </a>
        <div class="fundraising-secondary-row">
          <a
            class="fundraising-btn fundraising-btn-secondary"
            (click)="onPublicDetailsClicked.emit(project().id)"
          >
            <span class="bi bi-list"></span>
            {{ "projectCard.fundraising.publicDataSheet" | translate }}
          </a>
          <a
            class="fundraising-btn fundraising-btn-secondary"
            (click)="onEditWizardClicked.emit(project().id)"
          >
            <span class="bi bi-file-earmark-text"></span>
            {{ "projectCard.fundraising.dataForm" | translate }}
          </a>
        </div>
      </div>
    } @else {
      <div class="button-container">
        @if (showDetailsButton()) {
          <a
            class="btn btn-details"
            [class.btn-details-full-width]="detailsButtonFullWidth()"
            (click)="onDetailsClicked.emit(project().id)"
            ><span class="bi-list"></span>{{ "general.details" | translate }}</a
          >
        }
        @if (showFollow() && !investment()) {
          @if (!!projectsStore.allFollowedProjectEntityMap()[project().id]) {
            <a
              class="btn btn-outline-secondary btn-sm me-1 mb-1"
              (click)="unFollow(project().id)"
              ><span class="fas fa-star"></span
              >{{ "general.unFollow" | translate }}</a
            >
          } @else {
            <a
              class="btn btn-outline-secondary btn-sm me-1 mb-1"
              (click)="follow(project().id)"
              ><span class="fas fa-star"></span
              >{{ "general.follow" | translate }}</a
            >
          }
        }
      </div>
    }
  </div>
</div>
